import { render, staticRenderFns } from "./paymentreport.vue?vue&type=template&id=22fc0b25"
import script from "./paymentreport.vue?vue&type=script&lang=js"
export * from "./paymentreport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports